
.scenarioIconWrapper {
  display: inline-flex;
  cursor: pointer;
}
